<template>
  <div class="loading-container">
    <lottie :options="defaultOptions" :height="120" :width="120" v-on:animCreated="handleAnimation"/>
  </div>
</template>

<script>
  import Lottie from './Lottie.vue';
  import * as animationData from '../assets/animacoes/loading-iouu.json';

  export default {
    components: {
      'Lottie': Lottie
    },
    data() {
      return {
        defaultOptions: {animationData: animationData},
        animationSpeed: 10
      }
    },
    methods: {
      handleAnimation: function (anim) {
        this.anim = anim;
      }
    }
  }
</script> 

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";

  /* Absolute Center Spinner */
  .loading-container {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  /* Transparent Overlay */
  .loading-container:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($white, 0.95);
  }


  .loading-animation:before,
  .loading-animation:after,
  .loading-animation {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: animation-spec 1.8s infinite ease-in-out;
  }
  .loading-animation {
    color: $c3;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }
  .loading-animation:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  .loading-animation:after {
    left: 3.5em;
  }
  .loading-animation:before,
  .loading-animation:after {
    content: '';
    position: absolute;
    top: 0;
  }
  @-webkit-keyframes animation-spec {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @keyframes animation-spec {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue